import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { MdMoreVert } from 'react-icons/md';
import '../../../../assets/css/components/seller/dropdown/action/ActionDropdown.css';

const ActionDropdown = ({
  isOpen,
  onToggle,
  actions = [],
  className = ''
}) => {
  const wrapperRef = useRef(null);
  const btnRef = useRef(null);
  const [menuStyle, setMenuStyle] = useState({});

  // ✅ Close on outside click
  useEffect(() => {
    if (!isOpen) return;
    const handleOutside = (e) => {
      const clickedInsideMenu = e.target.closest('.action-dropdown-menu');
      if (wrapperRef.current && !wrapperRef.current.contains(e.target) && !clickedInsideMenu) {
        onToggle(false);
      }
    };
    document.addEventListener('mousedown', handleOutside);
    return () => document.removeEventListener('mousedown', handleOutside);
  }, [isOpen, onToggle]);

  // ✅ Scroll hone par dropdown band kar do — position stale ho jati hai
  useEffect(() => {
    if (!isOpen) return;
    const handleScroll = () => {
      onToggle(false);
    };
    window.addEventListener('scroll', handleScroll, true);
    return () => window.removeEventListener('scroll', handleScroll, true);
  }, [isOpen, onToggle]);

  // ✅ Button ke actual screen position se dropdown ki jagah calculate karo
  useEffect(() => {
    if (!isOpen || !btnRef.current) return;

    const rect = btnRef.current.getBoundingClientRect();
    const menuHeight = actions.length * 45 + 16;
    const spaceBelow = window.innerHeight - rect.bottom;
    const openUpward = spaceBelow < menuHeight;

    setMenuStyle({
      position: 'fixed',
      top: openUpward ? rect.top - menuHeight - 6 : rect.bottom + 6,
      right: window.innerWidth - rect.right,
    });
  }, [isOpen, actions.length]);

  return (
    <div ref={wrapperRef} className={`action-dropdown-wrapper ${className}`}>
      <button
        ref={btnRef}
        className="action-dropdown-btn"
        onClick={onToggle}
      >
        <MdMoreVert />
      </button>

      {isOpen && createPortal(
        <div className="action-dropdown-menu" style={menuStyle}>
          {actions.map((action, index) => (
            <button
              key={index}
              className={`action-dropdown-item ${action.variant || ''}`}
              onClick={() => {
                action.onClick?.();
                onToggle(false);
              }}
            >
              {action.icon && <span className="action-dropdown-icon">{action.icon}</span>}
              <span className="action-dropdown-label">{action.label}</span>
            </button>
          ))}
        </div>,
        document.body
      )}
    </div>
  );
};

export default ActionDropdown;
